import React from "react";
import Modal from "components/common/modals/modal/Modal";
import CiedDeviceInformationPreviewItem from "components/pages/transmissions/modal/patient/tabs/deviceInformation/preview/CiedDeviceInformationPreviewItem";
import { Grid } from "@mui/material";
import { Visibility } from "@mui/icons-material";

const PreviousDevicesPreviewModal = ({ previousDevices }) => {
  return (
    <div>
      <Modal
        buttonTitle="View All"
        modalTitle="Previous Devices"
        maxWidth="xl"
        buttonStyle={{ color: "#94BA33" }}
        buttonIcon={<Visibility />}
        content={
          <Grid container columnSpacing={3}>
            {previousDevices?.map((previousDevice, index) => (
              <CiedDeviceInformationPreviewItem
                key={index}
                deviceInformation={{
                  ...previousDevice,
                  modelName: previousDevice?.device_model,
                  modelNumber: previousDevice?.device_serial,
                }}
                isPreviousDevices={true}
              />
            ))}
          </Grid>
        }
      />
    </div>
  );
};

export default PreviousDevicesPreviewModal;
